import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import { PickupRequestCompany } from "../../types";

import styles from "./RequestCompanyBlock.module.scss";

interface Props {
  title: string;
  company: PickupRequestCompany | null | undefined;
  className?: string;
  editable?: boolean;
  participantLinkTo?: (companyId: number) => string;
}

const RequestCompanyBlock = (props: Props) => {
  const { title, company, className, editable, participantLinkTo } =
    props;

  const cityLine = [company?.city, company?.addressLine2]
    .filter(Boolean)
    .join(", ");
  const zoneLine =
    company?.municipalityName && company?.zoneName
      ? `${company.municipalityName} (${company.zoneName})`
      : company?.municipalityName || company?.zoneName;

  return (
    <div
      className={classnames(styles.block, className)}
      data-editable={editable}
    >
      <span className={styles.title}>
        {title}
        {!!company?.regNumber && (
          <>
            {" · "}
            {participantLinkTo && company.companyId ? (
              <Link
                className={styles.regNumber}
                to={participantLinkTo(company.companyId)}
              >
                {`#${company.regNumber}`}
              </Link>
            ) : (
              <span className={styles.regNumber}>{`#${company.regNumber}`}</span>
            )}
          </>
        )}
      </span>
      {company?.displayName && (
        <span className={styles.name}>{company.displayName}</span>
      )}
      <div className={styles.details}>
        {company?.addressLine1 && <span>{company.addressLine1}</span>}
        {cityLine && <span>{cityLine}</span>}
        {company?.phone && <span>{company.phone}</span>}
        {zoneLine && <span>{zoneLine}</span>}
      </div>
    </div>
  );
};

export default RequestCompanyBlock;
